import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';
import { properties } from '../../../environments/properties';
@Injectable({
  providedIn: 'root',
})
export class ParamService {
  private banners = Object.keys(environment.bannerConfiguration);
  private displayBanners = environment.bannerConfiguration;
  bannerConfiguration: string;
  banner: string;
  displayBanner: string;
  logoUrl: string;
  whiteLogoUrl: string;
  isUnifiedBanner = true;

  constructor() {
    this.banner = this.resolveBanner();
    this.displayBanner = this.resolveDisplayBanner();
    this.setLogoUrls();
 }

  // look through banner configurations and match with the hostname
  // if unable to match, default to jewelosco
  resolveBanner() {
    for (let i = 0; i < this.banners.length; i++) {
      const regex = new RegExp(this.banners[i]);
      if (regex.test(window.location.hostname)) {
        return this.banners[i];
      }
    }
    return 'safeway';
  }

    resolveDisplayBanner() {

        for (let i = 0; i < this.banners.length; i++) {
            const regex = new RegExp(this.banners[i]);
            if (regex.test(window.location.hostname)) {
                return this.displayBanners[this.banner].banner;
            }
        }
        return 'safeway';
    }

  removeAbActiveOrderLocalStorage() { // remove only on order confrimation page
    // This condition should help the view order status modal #2854
    if (localStorage.getItem('abActiveOrders')) {
      localStorage.removeItem('abActiveOrders');
    }
  }
  getUnifiedContext() {
      return 'account';
  }
  setLogoUrls() {
    const baseUrl = '/content/dam/logos/';
    this.bannerConfiguration = environment.bannerConfiguration[this.banner];
    if ((this.bannerConfiguration
    && this.bannerConfiguration['logoUrls'])
    && (this.bannerConfiguration['logoUrls']['color']
    && this.bannerConfiguration['logoUrls']['white'])) {
      this.logoUrl = baseUrl + this.bannerConfiguration['logoUrls']['color'];
      this.whiteLogoUrl =  baseUrl + this.bannerConfiguration['logoUrls']['white'];
    }
  }
}
